import React from 'react';
import clsx from 'clsx';
import { Link, useLocation } from "react-router-dom";
import { useLanguage } from '../../Contexts/LanguageContext';

import { Icon } from '../../Elements/Icon';

import strings from '../../strings';

const FooterMenu = () => {
    const location = useLocation();
    const { language } = useLanguage();

    const activeItem = location.pathname === '/' ? 'home' : 'guides';

    return (
        <div className="footer-menu">
            <Link 
                to={ '/' } 
                className={clsx("footer-menu__button", {
                    "footer-menu__button--active": activeItem === 'home'
                })}
            >
                <Icon name={ activeItem === 'home' ? 'home' : 'home-inactive' } additionalClasses="footer-menu__button__icon" withInlineStyle={false} />
                <span className="footer-menu__button__label">
                    {strings.FOOTER_MENU_HOME_LABEL[language]}
                </span>
            </Link>
            <Link 
                to={ '/guides' } 
                className={clsx("footer-menu__button", {
                    "footer-menu__button--active": activeItem === 'guides'
                })}
            >
                <Icon name={ activeItem === 'guides' ? 'headphones-active' : 'headphones' } additionalClasses="footer-menu__button__icon" withInlineStyle={false} />
                <span className="footer-menu__button__label">
                    {strings.FOOTER_MENU_GUIDES_LABEL[language]}
                </span>
            </Link>
        </div>
    );
}

export default FooterMenu;